import { render, staticRenderFns } from "./TagsInputConfig.vue?vue&type=template&id=b9073dec&scoped=true&"
import script from "./TagsInputConfig.vue?vue&type=script&lang=js&"
export * from "./TagsInputConfig.vue?vue&type=script&lang=js&"
import style0 from "./TagsInputConfig.vue?vue&type=style&index=0&id=b9073dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9073dec",
  null
  
)

export default component.exports